import React, { Component } from 'react';
import Icon from '../components/Icon';

class ProgressBar extends Component {
    constructor(props){
        super(props);

        this.handlePrevious = this.handlePrevious.bind(this);
    }

    handlePrevious(){
        if(this.props.pageNumber > 0){
            this.props.handlePrevious();
        }
    }

    render(){
        var progressWidth = Math.floor((this.props.pageNumber/this.props.pageCount) * 100);
        var style = {
            width: progressWidth + '%'
        };
        return (
            <div className="isg_progress_bar">
                <div className="isg_panel_content">
                    <div className="isg_pb_nav">
                        <div className={"isg_pbn_prev" + (this.props.pageNumber === 0 ? " isg_pbn_disabled" : "")} onClick={this.handlePrevious}>
                            <Icon value="icon_retour" />
                        </div>
                    </div>
                    <div className="isg_progress_bar_bg">
                        <div className="isg_progress_bar_fill" style={style}></div>
                    </div>
                </div>
            </div>
        );
    }

}

ProgressBar.propTypes = {
    pageCount: React.PropTypes.number.isRequired,
    pageNumber: React.PropTypes.number.isRequired,
    handlePrevious: React.PropTypes.func.isRequired
};

export default ProgressBar;


/** WEBPACK FOOTER **
 ** ./src/components/ProgressBar.js
 **/